export default {
  namespaced: true,
  state: () =>  ({
    errorCode: '',
    errorMessage: '',
    debugMessage: '',
  }),
  getters: {
    errorCode: (state) => state.errorCode,
    errorMessage: (state) => state.errorMessage,
    debugMessage: (state) => state.debugMessage,
  },
  mutations:{
    setErrorCode: (state, errorCode) => state.errorCode = errorCode,
    setErrorMessage: (state, errorMessage) => state.errorMessage = errorMessage,
    setDebugMessage: (state, debugMessage) => state.debugMessage = debugMessage,
  },
}
